import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { CompanyProfileComponent } from './company-profile/company-profile.component';
import { VisionMissionComponent } from './vision-mission/vision-mission.component';
import { CompanyMilestoneComponent } from './company-milestone/company-milestone.component';
import { ShareholderComponent } from './shareholder/shareholder.component';
import { CEOMessageComponent } from './ceomessage/ceomessage.component';
import { ManagementComponent } from './management/management.component';
import { OrganizationChartComponent } from './organization-chart/organization-chart.component';
import { CodeOfConductComponent } from './code-of-conduct/code-of-conduct.component';
import { HousingLoanComponent } from './ProductServices/housing-loan/housing-loan.component';
import { MicroLoanComponent } from './ProductServices/micro-loan/micro-loan.component';
import { SmallBusinessLoanComponent } from './ProductServices/small-business-loan/small-business-loan.component';
import { SmeLoanComponent } from './ProductServices/sme-loan/sme-loan.component';
import { WashLoanComponent } from './ProductServices/wash-loan/wash-loan.component';
import { MigrantLoanComponent } from './ProductServices/migrant-loan/migrant-loan.component';
import { PublishedReportComponent } from './Publications/published-report/published-report.component';
import { KeyFinancialComponent } from './Publications/key-financial/key-financial.component';
import { KeyOperationalComponent } from './Publications/key-operational/key-operational.component';
import { CsrComponent } from './Publications/csr/csr.component';
import { CareerComponent } from './career/career.component';
import { CareerDetailComponent } from './career/career-detail/career-detail.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { GalleryComponent } from './gallery/gallery.component';
import { GalleryDetailComponent } from './gallery/gallery-detail/gallery-detail.component';
import { VideoComponent } from './gallery/video/video.component';
import { SiteMapComponent } from './site-map/site-map.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { DownloadAppComponent } from './download-app/download-app.component';
import { WhatNewComponent } from './what-new/what-new.component';
import { WhatNewDetailComponent } from './what-new-detail/what-new-detail.component';
import { AllPostsComponent } from './all-posts/all-posts.component';
import { PostDetailComponent } from './post-detail/post-detail.component';
import { TestingMapComponent } from './testing-map/testing-map.component';
import { CeomessageV2Component } from './ceomessage-v2/ceomessage-v2.component';

export const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
    },
    {
        path: 'company-profile',
        component: CompanyProfileComponent
    },
    {
        path: 'vision-mission',
        component: VisionMissionComponent
    },
    {
        path: 'company-milestone',
        component: CompanyMilestoneComponent
    },
    {
        path: 'shareholder',
        component: ShareholderComponent
    },
    {
        path: 'ceo-message',
        component: CeomessageV2Component
    },
    {
        path: 'management',
        redirectTo: 'management/1',
        pathMatch: 'full'
    },
    {
        path: 'management/:page',
        component: ManagementComponent
    },
    {
        path: 'organization-chart',
        component: OrganizationChartComponent
    },
    {
        path: 'code-of-conduct',
        component: CodeOfConductComponent
    },
    {
        path: 'product-service',
        children: [
            {
                path: 'housing-loan',
                component: HousingLoanComponent
            },
            {
                path: 'micro-loan',
                component: MicroLoanComponent
            },
            {
                path: 'small-business-loan',
                component: SmallBusinessLoanComponent
            },
            {
                path: 'sme-loan',
                component: SmeLoanComponent
            },
            {
                path: 'wash-loan',
                component: WashLoanComponent
            },
            {
              path: 'migrant-worker-loan',
              component: MigrantLoanComponent
          }
        ]
    },
    {
        path: 'publication',
        children: [
            {
                path: 'published-report',
                component: PublishedReportComponent
            },
            {
                path: 'key-financial',
                component: KeyFinancialComponent
            },
            {
                path: 'key-operational',
                component: KeyOperationalComponent
            },
            {
                path: 'csr',
                component: CsrComponent
            },
        ]
    },
    {
        path: 'what-new',
        children: [
            {
                path: '',
                component: WhatNewComponent
            },
            {
                path: 'detail/:id',
                component: WhatNewDetailComponent
            }
        ]
    },
    // {
    //     path: 'what-new',
    //     children: [
    //         {
    //             path: '',
    //             redirectTo: '1',
    //             pathMatch: 'full'
    //         },
    //         {
    //             path: ':page',
    //             component: WhatNewComponent
    //         },
    //         {
    //             path: 'detail',
    //             children: [
    //                 {
    //                     path: 'nonghyup-bank',
    //                     component: NonghyupBankComponent
    //                 },
    //                 {
    //                     path: 'new-experience',
    //                     component: NewExperienceComponent
    //                 },
    //                 {
    //                     path: 'material-contribution',
    //                     component: MaterialContributionComponent
    //                 },
    //                 {
    //                     path: 'nh-donate',
    //                     component: NhDonateComponent
    //                 },
    //                 {
    //                     path: 'chair-contribution',
    //                     component: ChairContributionComponent
    //                 },
    //                 {
    //                     path: 'stuff-food',
    //                     component: StuffFoodComponent
    //                 },
    //                 {
    //                     path: 'school-donate',
    //                     component: SchoolDonateComponent
    //                 },
    //                 {
    //                     path: 'water-festival',
    //                     component: WaterFestivalComponent
    //                 },
    //                 {
    //                     path: 'annual-staff',
    //                     component: AnnualStaffComponent
    //                 },
    //                 {
    //                     path: 'grand-opening',
    //                     component: GrandOpeningComponent
    //                 }
    //             ]
    //         }
    //     ]
    // },
    {
        path: 'career',
        children: [
            {
                path: '',
                component: CareerComponent
            },
            {
                path: 'detail/:id',
                component: CareerDetailComponent
            }
        ]
    },
    {
        path: 'contact-us',
        component: ContactUsComponent
    },
    {
        path: 'site-map',
        component: SiteMapComponent
    },
    {
        path: 'all-posts',
        children: [
            {
                path: '',
                component: AllPostsComponent
            },
            {
                path: 'detail/:id',
                component: PostDetailComponent
            }
        ]
    },
    {
        path: 'gallery',
        children: [
            {
                path: '',
                component: GalleryComponent
            },
            {
                path: 'gallery-detail/:id',
                component: GalleryDetailComponent
            },
            {
                path: 'video',
                component: VideoComponent
            }
        ]
    },
    {
        path: 'feedback',
        component: FeedbackComponent
    },
    {
        path: 'download-app',
        component: DownloadAppComponent
    },
    {
        path: 'testing-map',
        component: TestingMapComponent
    },
    { path: '**', redirectTo: '', pathMatch: 'full' }
];

